import {AfterViewInit, Component, Inject, OnDestroy, ViewChild, ViewEncapsulation, ChangeDetectionStrategy} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ReplaySubject} from "rxjs";
import {PageService} from "@irb-common/services/page.service";
import {AppService} from "@irb/app.service";
import {TooltipService} from "@irb-common/components/tooltip/tooltip.service";
import {ICreateModel, ModelsService} from "@irb/irb-models//models-new/models.service";
import {IrbAppEvents, IrbModelsEvents} from "@irb-common/events";

@Component({ standalone: false,
  selector: "irb-create-security-model-dialog",
  templateUrl: "./create-security-model-dialog.component.html",
  styleUrls: ["./create-security-model-dialog.component.scss", "../../irb-common/styles/dialog.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class CreateSecurityModelDialogComponent implements OnDestroy, AfterViewInit {
  @ViewChild("modelNameField") modelNameField: any;
  @ViewChild("modelDescField") modelDescField: any;
  modelName: string = "";
  modelDesc: string;
  modelNameInUse: boolean = false;
  modelCanResurrect: boolean = false;
  resurrectOption: string = "Restore";
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  callToActionText: string;
  callBack: Function;
  isAltWorkflow: boolean;
  canNotContinue: boolean = true;
  parseData: any;
  tooltipMessage: any = "";
  tooltipDescMessage: any = "";
  //tooltipShow: boolean = false;

  constructor(public dialogRef: MatDialogRef<CreateSecurityModelDialogComponent>, public ps: PageService, public modelService: ModelsService, public as: AppService, public tts: TooltipService, @Inject(MAT_DIALOG_DATA) public mdd: any) {}

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.modelNameField && this.modelNameField.inputField && this.modelNameField.inputField.nativeElement) {
        this.modelNameField.inputField.nativeElement.focus();
      }
    },100);
  }

  close() {
    this.tts.remove();
    this.dialogRef.close();
  }

  checkIfNameExists() {
    const r = {} as ICreateModel;
    r.modelType = "Base";
    if (this.modelNameField.inputControl) {
      r.modelName = this.modelNameField.inputControl.value;
    }
    r.modelDescription = this.modelDesc;
    this.modelService.createSecurityModel(r).subscribe((data: any) => {
      if (data.alreadyExisting) {
        this.modelNameInUse = true;
      } else {
        data.fullscreen = true;
        data.type = "Base";
        data.isDraft = true;
        data.onClose = () => {
           this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
             severity: "warn",
             summary: "Incomplete Security Model",
             detail: "To use this model, allocations must equal 100%."
           });
          this.as.fireEvent(IrbAppEvents.GRID_REFRESH, { 'slot': 'A' });
        };
        this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL, data);
        this.close();
      }
    });
  }

  onInputChange() {
    setTimeout(() => {
      this.canNotContinue = !this.modelName.trim() || !this.modelNameField.inputControl.valid;
      if (this.modelName.length === 100) {
        this.tooltipMessage = "100 characters max";
      } else {
        this.tooltipMessage = "";
      }
    });
  }

  onDescChange(){
    setTimeout(() => {

      if (this.modelDescField.inputControl.value && this.modelDesc.length === 100) {
        this.tooltipDescMessage = "100 characters max";
      } else {
        this.tooltipDescMessage = "";
      }
    });

  }
}
